import { render } from "./Sidebar.vue?vue&type=template&id=9cb08a34"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Hp\\Ilir\\BaboonPos\\baboon-pos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__